import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import ClientsPage from './pages/ClientsPage';
import PaymentsPage from './pages/PaymentsPage';
import TasksPage from './pages/TasksPage';
import UsersPage from './pages/UsersPage';
import Layout from './components/Layout';
import './App.css';

// Protected Route Component
function ProtectedRoute({ children, adminOnly = false }) {
    const { isAuthenticated, isAdmin, loading } = useAuth();

    if (loading) {
        return <div className="loading-screen">Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (adminOnly && !isAdmin) {
        return <Navigate to="/dashboard" />;
    }

    return children;
}

function AppRoutes() {
    const { isAuthenticated, isAdmin } = useAuth();

    return (
        <Routes>
            <Route path="/login" element={
                isAuthenticated ? <Navigate to="/dashboard" /> : <Login />
            } />
            
            <Route path="/" element={
                <ProtectedRoute>
                    <Layout />
                </ProtectedRoute>
            }>
                <Route index element={<Navigate to="/dashboard" />} />
                
                <Route path="dashboard" element={
                    isAdmin ? <AdminDashboard /> : <EmployeeDashboard />
                } />
                
                <Route path="clients" element={
                    <ProtectedRoute adminOnly={true}>
                        <ClientsPage />
                    </ProtectedRoute>
                } />
                
                <Route path="payments" element={
                    <ProtectedRoute adminOnly={true}>
                        <PaymentsPage />
                    </ProtectedRoute>
                } />
                
                <Route path="tasks" element={
                    <ProtectedRoute>
                        <TasksPage />
                    </ProtectedRoute>
                } />
                
                <Route path="users" element={
                    <ProtectedRoute adminOnly={true}>
                        <UsersPage />
                    </ProtectedRoute>
                } />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppRoutes />
            </Router>
        </AuthProvider>
    );
}

export default App;
